// extracted by mini-css-extract-plugin
export default {"wrapper":"DiscountPage_wrapper__uJXy6"};